import { generateDOBTokenApi } from './index'

export default generateDOBTokenApi.middleware
